import polyfill from './polyfill';
import tip from './tip';
polyfill.init = true;

export function date (date) {
    if (typeof date !== 'string') {
        return '';
    }
    var result = dateHorToChinese(date.split(' ')[0]).split('年');
    return result[1] || result[0];
}
// 千分位处理
export function currencyFormat (value) {
    value = value || 0;
    return ('' + value).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
}
// xxxx-xx-xx 转 xxxx年xx月xx日
export function dateHorToChinese (value) {
    var result = value.split('-');
    if (result.length === 1) {
        return result[0];
    }
    return result[0] + '年' + (+result[1]) + '月' + result[2] + '日';
}
// YYYY-mm-dd hh:mm:ss => d
export function date2Day (value) {
    var date = (value || '').split(' ')[0].split('-');
    if (!date || !date[2]) {
        return '';
    }
    return +date[2];
}
// YYYY-mm-dd hh:mm:ss => mm月dd日
export function date2Mday (value, format) {
    var date = (value || '').split(' ')[0].split('-');
    if (!date || !date[1] || !date[2]) {
        return '';
    }
    if (!format) {
        return +date[1] + '月' + (+date[2]) + '日';
    } else {
        return format(+date[1], +date[2]);
    }
}
// 时间戳 => YYYY年M月D日
export function timeStampToYMD (timeStamp) {
    const dateObj = new Date(timeStamp);
    const dateMidType = timeFromat(dateObj);
    return date2YMD(dateMidType);
}
// 时间戳 => YYYY年M月
export function timeStampToYM (timeStamp) {
    const dateObj = new Date(timeStamp);
    const dateMidType = timeFromat(dateObj);
    return date2YM(dateMidType);
}

// 时间戳 => M月D日
export function timeStampToMD (timeStamp) {
    const dateObj = new Date(timeStamp);
    const dateMidType = timeFromat(dateObj);
    return date2Mday(dateMidType);
}

// YYYY-MM-DD hh:mm:ss => YYYY年M月D日
export function date2YMD (value) {
    var date = (value || '').split(' ')[0].split('-');
    if (!date || !date[0] || !date[1] || !date[2]) {
        return '';
    }
    return +date[0] + '年' + (+date[1]) + '月' + (date[2]) + '日';
}

// YYYY-MM-DD hh:mm:ss => YYYY年M月
export function date2YM (value) {
    var date = (value || '').split(' ')[0].split('-');
    if (!date || !date[0] || !date[1] || !date[2]) {
        return '';
    }
    return +date[0] + '年' + (+date[1]) + '月';
}
export function timeFromat (dateObj, fmt = 'yyyy-MM-dd hh:mm:ss') {
    let obj = {
        'M+': dateObj.getMonth() + 1, // 月份
        'd+': dateObj.getDate(), // 日
        'h+': dateObj.getHours(), // 小时
        'm+': dateObj.getMinutes(), // 分
        's+': dateObj.getSeconds(), // 秒
        'q+': Math.floor((dateObj.getMonth() + 3) / 3), // 季度
        'S': dateObj.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    for (let item of Object.keys(obj)) {
        if (new RegExp('(' + item + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (obj[item]) : (('00' + obj[item]).substr(('' + obj[item]).length)));
        }
    }
    return fmt;
};
export function obj2Url (obj) {
    return Object.keys(obj).map(v => {
        return v + '=' + obj[v];
    }).join('&');
}
// 时间戳 -> 2018.07.09 09:09:56
export function timeStampFormat (stamp) {
    let time = new Date(+stamp);
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let day = time.getDate();
    let hour = time.getHours();
    let min = time.getMinutes();
    let sec = time.getSeconds();
    month = month > 9 ? month : '0' + month;
    day = day > 9 ? day : '0' + day;
    min = min > 9 ? min : '0' + min;
    sec = sec > 9 ? sec : '0' + sec;
    hour = hour > 9 ? hour : '0' + hour;
    return year + '.' + month + '.' + day + ' ' + hour + ':' + min + ':' + sec;
}
// 获取cookie
export function getCookie (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return unescape(c.substring(nameEQ.length, c.length));
        }
    }
    return '';
}

export function getUrlFrom () {
    return decodeURIComponent((/from=([^&]+)/.exec(location.search) || ['', '/'])[1]);
}

// 设置 cookie
export function setCookie (name, value, domain, seconds) {
    seconds = seconds || 30 * 24 * 60 * 60;
    var host = location.hostname.split('.');
    domain = domain || (host.length > 1 ? '.' : '') + host.slice(-2).join('.');
    var expires = '';
    if (seconds !== 0) {
        var date = new Date();
        date.setTime(date.getTime() + (seconds * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + escape(value) + expires + `; Domain=${domain}` + '; path=/';
}
// 删除cookie
export function clearCookie (name) {
    setCookie(name, '', -1);
}
export function appendQuery (url, key, value) {
    if (url.indexOf('?') === -1) {
        url += '?';
    } else {
        url += '&';
    }
    url += encodeURIComponent(key) + '=' + encodeURIComponent(value);
    return url;
}
// 当前页面地址中的参数添加到url
export function appendUrlSearch (url) {
    let search = location.search;
    if (url.indexOf('?') !== -1) { // 链接包含?
        url += '&' + search.substring(1); // search中会包含？
    } else {
        url += search;
    }
    return url;
}

// query参数
export function getParamFromSearch (key) {
    const params = {};
    if (location.search) {
        location.search.substring(1).split('&').forEach((it) => {
            let arr = it.split('=');
            params[arr[0]] = arr[1];
        });
    }
    return decodeURIComponent(params[key] || '');
}
export function getParamFromUrl (url, key) {
    const params = {};
    let index = url.indexOf('?');
    let search;
    if (index > -1) {
        search = url.substr(index + 1);
        search.split('&').forEach((it) => {
            let arr = it.split('=');
            params[arr[0]] = arr[1];
        });
    }
    return decodeURIComponent(params[key] || '');
}
export function getAppCode (ua) {
    let code = -1;
    if (/meituangroup/i.test(ua) || /mt\//i.test(ua)) {
        code = 0;
    } else if (/dianping/i.test(ua)) {
        code = 11;
    } else if (/waimai/i.test(ua)) {
        code = 4;
    } else if (/qcsc/i.test(ua)) {
        code = 35;
    } else if (/phoenix/i.test(ua)) {
        code = 30;
    } else if (/retail/i.test(ua)) {
        code = 31;
    } else {
        code = -1;
    }
    return code;
};

export function getAppCodeForAD (appName) {
    let code = 0;
    if (/meituangroup/i.test(appName)) {
        code = 1;
    } else if (/dianping/i.test(appName)) {
        code = 2;
    } else if (/waimai/i.test(appName)) {
        code = 3;
    } else if (/qcsc/i.test(appName)) {
        code = 5;
    }
    return code;
};

export function getPlatform (ua) {
    // 数字对应关系  https://km.sankuai.com/page/28233089#id-%E6%B6%88%E8%B4%B9%E9%87%91%E8%9E%8D%E6%8B%BC%E5%9B%A2%E5%8A%A9%E5%8A%9B%E6%B4%BB%E5%8A%A8%E5%BF%85%E4%BC%A0%E5%8F%82%E6%95%B0
    if (typeof ua === 'object') {
        ua = JSON.stringify(ua);
    }
    // 先判断是否是微信环境
    if (/micromessenger/i.test(ua)) {
        return 11;
    } else if (/android/i.test(ua)) {
        return 4;
    } else if (/(ipad|iphone|ipod).*os\s([\d_]+)/i.test(ua)) {
        return 5;
    }
};

export const getAppType = (ua) => {
    let type = '';
    // 盘古，大象，蜜蜂ua https://km.sankuai.com/page/178325091
    if (/arm.moma/i.test(ua)) { // 防止美团前面，android盘古的ua中也包含mt
        type = 'pangu';
    } else if (/com.dianping.crm/i.test(ua) || /dpcrm/i.test(ua)) { //阿波罗
        type = 'apollo';
    } else if (/meituanwaimai_bee/i.test(ua)) {
        type = 'mifeng';
    } else if (/meituanwaimaibusiness/i.test(ua) || /meituanwaimai-b/i.test(ua)) {
        // 外卖商家版app在ios和安卓上的ua标识不一致，meituanwaimaibusiness为安卓，meituanwaimai-b为ios
        type = 'waimaibusiness';
    } else if (/xm\//i.test(ua)) {
        type = 'daxiang';
    } else if (/meituangroup/i.test(ua) || /mt\//i.test(ua)) {
        type = 'meituan';
    } else if (/dianping/i.test(ua)) {
        type = 'dianping';
    } else if (/waimai/i.test(ua)) {
        type = 'waimai';
    } else if (/qcsc/i.test(ua)) {
        type = 'dache';
    } else if (/phoenix/i.test(ua)) {
        type = 'zhenguo';
    } else if (/retail/i.test(ua)) {
        type = 'xiaoxiang';
    }
    return type;
};
export const debounce = (fn, wait) => {
    let timeout = null;
    return function () {
        const args = [].slice.call(arguments, 0);
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            fn.apply(null, args);
        }, wait);
    };
}
export const throttle = (fn, wait)=> {
    wait = wait || 0;
    let timerId;

    function throttled() {
        const args = [].slice.call(arguments, 0);
        if (timerId) {
            clearTimeout(timerId);
            timerId = null;
        }
        timerId = setTimeout(function () {
            fn.apply(null, args);
        }, wait);
    }
    return throttled;
}

export const getMobileSystem = () => {
    if (/iphone/gi.test(navigator.userAgent) && window.screen.height >= 812) {
        return 'iphone'; // iphone X系列
    } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(navigator.userAgent)) {
        return 'iphone'; // 一般iphone
    } else  {
        return 'android';
    }
};

export const checkMobileType = () => {
    if (typeof __CLIENT === 'undefined') { return ''; }
    if (/iphone/gi.test(navigator.userAgent) && window.screen.height >= 812) {
        return 'iphoneX'; // iphone X系列
    } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(navigator.userAgent)) {
        return 'iphoneNormal'; // 一般iphone
    } else if (/dianping/i.test(navigator.userAgent)) {
        return 'androidDP';
    } else {
        return 'android';
    }
};
// 跳转加时间戳 解决安卓微信内缓存问题，拼团手动加 这里抽成函数
export const jumpWithStamp = (url, native, notitlebar) => {
    if (native) {
        KNB.openPage({
            url,
            query: {
                _knbopeninapp: 1,
                notitlebar: notitlebar ? 1: 0
            },
            fail: function(error) {
                console.log('KNB.openPage', error);
            }
        });
    } else {
        location.href = url;
    }
};

export const jumpUrl = (url) => {
    KNB.openPage({
        url,
        query: {
            _knbopeninapp: 1
        }
    });
}

export const replaceWithStamp = (url, native, notitlebar) => {
    if (native) {
        KNB.openPage({
            url,
            query: {
                _knbopeninapp: 1,
                notitlebar: notitlebar ? 1: 0
            }
        });
    } else {
        location.replace(url);
    }
};

// tip 提示
export const info = (info, native) => {
    if (native) {
        KNB.toast({
            content: info
        });
    } else {
        tip.info(info);
    }
};

// stamp -> x月x日
export const formatEndDate = (time) => {
    let date = timeStampFormat(time);
    date = date.split(' ')[0];
    let dateAry = date.split('.');
    return `${Number(dateAry[1])}月${Number(dateAry[2])}日`;
};

export const getAppEnv = (ua) => {
    return {
        isInWeixin: /micromessenger/i.test(ua),
        isInIos: /(ipad|iphone|ipod).*os\s([\d_]+)/i.test(ua),
        isInAndroid: /android/i.test(ua)
    };
};

// 字符串占位格式化
// var str1 = "我叫{0},性别{1}".format("123", "男");
export const stringFormat = (str, ...param) => {
    if (!str || !param || param.length === 0) return str;
    let s = str;
    for (let i = 0; i < param.length; i++) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), param[i]);
    }
    return s;
};

/**
 * 替换url中的参数。有对应的key就替换，没有就追加到url上
 */
export const replaceUrlParams = (url, key, val) => {
    if (!url) {
        return '';
    }
    if (!key) {
        return url;
    }
    var pattern = key + '=([^&]*)';
    var replaceText = key + '=' + val;
    let replace = `(${key}=)([^&]*)`;
    return url.match(pattern) ? url.replace(new RegExp(replace, 'g'), replaceText) : (url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText);
};

export const random = () => {
    return Math.random().toString(36).slice(-8);
};

export const isEmptyObj = (obj) => {
    return obj ? Object.keys(obj).length === 0 : false;
};

export const calcuText = (data, patternConfig) => {
    try {
        let text = patternConfig.pattern;
        patternConfig.items.forEach((i, index) => {
            let value = 0;
            if (typeof i === 'object' && i.calc && i.key) {
                value = data[i.key] / i.calc;
            } else {
                value = data[i];
            }
            text = text.replace(`{${index}}`, value || 0);
        });
        return text;
    } catch (error) {
        return '';
    }
};

export const getDeviceType = () => {
    if (/iphone/gi.test(navigator.userAgent) && window.screen.height >= 812) {
        return 'iphoneX'; // iphone X系列
    } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(navigator.userAgent)) {
        return 'iphoneNormal'; // 一般iphone
    } else {
        return 'android';
    }
};

// 大于 小于 等于
const GRE = 1;
const LESS = -1;
const EQU = 0;

function _stringCompare (str1 = '0', str2 = '0') {
    if (str1 === str2) {
        return EQU;
    }
    const num1 = Number(str1);
    const num2 = Number(str2);

    // 如果有一个纯数字就按字符串比较
    if (isNaN(num1) || isNaN(num2)) {
        return str1 > str2 ? GRE : LESS;
    }
    return num1 > num2 ? GRE : LESS;
}

// 版本号大小比较，不支持带字幕的版本号比较  例 1.5.10 < 1.23.1    1.5.0 > 1.5
export const versionCompare = (baseVersion = '', version = '') => {
    let result = 0;
    const baseArr = baseVersion.split('.');
    const versionArr = version.split('.');
    if (baseArr.length === 0 && versionArr.length === 0) {
        return EQU;
    } else if (baseArr.length === 0) {
        return LESS;
    } else if (versionArr.length === 0) {
        return GRE;
    }

    const maxLen = Math.max(baseArr.length, versionArr.length);
    // 循环比较数组内元素
    for(let i = 0; i < maxLen; i++) {
        result = _stringCompare(baseArr[i], versionArr[i]);
        if (result !== EQU) {
            break;
        }
    }
    return result;
};
// 计算百分比
export const getPercent = (num, total) => {
    if (num == 0 || total == 0){
        return 0;
    }
    return (Math.round(num / total * 10000) / 100.00)
};

// 计算百分比
export const isPhoneNumber = (phone) => {
    return /^1\d{10}$/.test(phone);
};

export function pxToRem(px) {
    if (px) {
        return (px / 100).toFixed(2) + 'rem';
    } else {
        return px;
    }
}